/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A request to create or update a research session
 * @export
 * @interface ResearchSessionRequest
 */
export interface ResearchSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof ResearchSessionRequest
     */
    prompt?: string;
}

/**
 * Check if a given object implements the ResearchSessionRequest interface.
 */
export function instanceOfResearchSessionRequest(value: object): value is ResearchSessionRequest {
    return true;
}

export function ResearchSessionRequestFromJSON(json: any): ResearchSessionRequest {
    return ResearchSessionRequestFromJSONTyped(json, false);
}

export function ResearchSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
    };
}

export function ResearchSessionRequestToJSON(json: any): ResearchSessionRequest {
    return ResearchSessionRequestToJSONTyped(json, false);
}

export function ResearchSessionRequestToJSONTyped(value?: ResearchSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
    };
}

